var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"ui-table-cell-digital-currency"},[_c('app-watch-flag',{staticClass:"m-r-8",attrs:{"isSelected":_vm.hasAtWatchlist,"isDisabled":_vm.isDisabled},on:{"isSelectedChanged":_vm.changeHasAtWatchlist}}),_c('app-link',{staticClass:"ui-table-cell-digital-currency_link",attrs:{"href":_vm.url,"text":_vm.text}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }